import Papa from 'papaparse'

export type Row = Record<string, string>

export async function fetchCsv(url: string): Promise<{ rows: Row[]; errors: string[] }> {
  const res = await fetch(url)
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  const text = await res.text()
  const parsed = Papa.parse<Row>(text, {
    header: true,
    skipEmptyLines: 'greedy',
    transformHeader: (h) => h.replace(/^\uFEFF/, '').trim(),
    transform: (v) => (typeof v === 'string' ? v.trim() : v),
  })
  return {
    rows: parsed.data,
    errors: parsed.errors.map((e) => `Fila ${e.row !== undefined ? e.row + 2 : '?'}: ${e.message}`),
  }
}

/** Vacío = sin dato. */
export const str = (v?: string): string | undefined => (v === undefined || v === '' ? undefined : v)

export const num = (v?: string): number | undefined => {
  const s = str(v)
  if (s === undefined) return undefined
  const n = Number(s)
  return Number.isFinite(n) ? n : undefined
}

export const bool = (v?: string): boolean | undefined => {
  const s = str(v)?.toLowerCase()
  if (s === 'true' || s === '1') return true
  if (s === 'false' || s === '0') return false
  return undefined
}

/** JSON dentro de una celda. Acepta también el formato Python (True/False/None, comillas simples). */
export function parseJson<T>(s: string): T | undefined {
  try {
    return JSON.parse(s) as T
  } catch {
    try {
      return JSON.parse(s.replace(/'/g, '"').replace(/\bNone\b/g, 'null').replace(/\bTrue\b/g, 'true').replace(/\bFalse\b/g, 'false')) as T
    } catch {
      return undefined
    }
  }
}
